import Vue from 'vue';

document.addEventListener('DOMContentLoaded', () => {
  var app = new Vue({
    el: '#app',
    data: {ad_id: ""},
    watch: {
      ad_id: function(v) {
        this.ad_id = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248)
        })
      },
    },
  });
});
